import { track } from './tracking';
import { getTiming } from './timing';

const UserInteractionEventName = 'Interaction Timed';

export interface TrackUserInteractionProps {
  eventName: string;
}

export interface TrackUserInteractionWithTimingProps {
  eventName: string;
  timing: number;
  eventDetail?: string;
}

export function trackUserInteractionWithTiming(
  props: TrackUserInteractionWithTimingProps
) {
  if (!props.eventName) {
    throw new Error('Missing eventName');
  }

  try {
    track(UserInteractionEventName, {
      eventName: props.eventName,
      timing: props.timing,
      eventDetail: props.eventDetail,
    });
  } catch (error) {
    console.error(
      'Something went wrong in @vp/track-user-interaction -> trackUserInteractionWithTiming',
      error
    );
  }
}

export function trackUserInteraction(props: TrackUserInteractionProps) {
  if (!props.eventName) {
    throw new Error('Missing eventName');
  }

  try {
    const timing = getTiming(props.eventName);

    trackUserInteractionWithTiming({
      eventName: props.eventName,
      timing: timing,
    });
  } catch (error) {
    console.error(
      'Something went wrong in @vp/track-user-interaction -> trackUserInteraction',
      error
    );
  }
}
